<template>
  <table class="table">
    <tbody>
      <tr>
        <td class="table-col">Серия</td>
        <td>{{ documentData.series }}</td>
      </tr>
      <tr>
        <td>Номер</td>
        <td>{{ documentData.number }}</td>
      </tr>
      <tr>
        <td>Дата выдачи</td>
        <td>{{ documentData.issue_date | diffForHumans }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { djsMixin } from '@/mixins/djsMixin'

export default {
  name: 'DocumentStsView',
  mixins: [djsMixin],
  props: ['documentData']
}
</script>

<style scoped>
  .table-col {
    width: 50%;
  }
</style>
